import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { PageHeader } from "../../components/PageHeader";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

const ESTADOS = ["nueva", "contactada", "descartada"];

export default function Demos() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/demos").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);
  const set = async (id, estado) => {
    try {
      await api.put(`/admin/demos/${id}`, { estado });
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-6" data-testid="admin-demos">
      <PageHeader overline="Superadmin" title="Solicitudes de demo" />
      <Table>
        <TableHeader><TableRow>{["Fecha", "Nombre", "Empresa", "WhatsApp", "Correo", "Estado"].map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
        <TableBody>
          {items.map((d) => (
            <TableRow key={d.id} data-testid={`demo-row-${d.id}`}>
              <TableCell>{new Date(d.fecha).toLocaleString("es-CL", { timeZone: "America/Santiago" })}</TableCell>
              <TableCell>{d.nombre}</TableCell>
              <TableCell>{d.empresa}</TableCell>
              <TableCell><a className="underline" href={`https://wa.me/${d.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer">{d.whatsapp}</a></TableCell>
              <TableCell><a className="underline" href={`mailto:${d.correo}`}>{d.correo}</a></TableCell>
              <TableCell>
                <select value={d.estado} onChange={(e) => set(d.id, e.target.value)} className="border rounded px-2 py-1 text-sm" data-testid={`demo-estado-${d.id}`}>
                  {ESTADOS.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </TableCell>
            </TableRow>
          ))}
          {!items.length && <TableRow><TableCell colSpan={6} className="text-slate-500">Aún no hay solicitudes.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  );
}
